import layout1 from './layout1/Layout1';

const themeLayouts = {
  layout1,
};

export default themeLayouts;
